<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Возврат</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол /</span> Возврат</div>
                </div>
              </v-col>
              <v-col>
                <v-sheet class="card rounded-lg d-flex flex-wrap">
                  <div class="column">
                    <VueDatePicker
                        no-title
                        no-header
                        range
                        rangeInputText="%d - %d"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="date"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__button"
                            ref="activator"
                            type="button"
                        >
                          <v-icon
                              dark
                              right
                              small
                              class="mr-2"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>  {{ date }}
                        </button>
                      </template>
                    </VueDatePicker>
                  </div>
                  <div class="column mt-5">
                    {{ client.name }}
                  </div>
                  <div class="column mt-5">
                    <v-btn
                        :to="{ name: 'ReturnService', params: {client: client} }"
                        dark
                        class="filter-button"
                        style="margin: 0 !important; width: 355px; padding: 22px 0 !important;"
                    >
                      Возврат товаров и услуг
                    </v-btn>
                  </div>
                  <div class="column mt-5">
                    <v-btn
                        :to="{ name: 'ReturnCancelPayment', params: {client: client} }"
                        dark
                        class="filter-button"
                        style="margin: 0 !important; width: 355px; padding: 22px 0 !important;"
                    >
                      Отмена ошибочной оплаты
                    </v-btn>
                  </div>
                                   <div class="column mt-5">
                                     <v-btn
                                          :to="{ name: 'Desktop', params: {to_bill_return: true} }"
                                          dark
                                          class="filter-button"
                                          style="margin: 0 !important; width: 355px; padding: 22px 0 !important;"
                                      >
                                        Возврат с лицевого счета
                                      </v-btn>
                                    </div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>

        
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {getItem, setItem} from "../helpers/persistanceStorage";
export default {
  name: "Return",
  props: ['client'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  data () {
    return {
      date: new Date(),
    }
  },
  mounted() {
    this.client !== undefined ? setItem('return-client',JSON.stringify(this.client)) : this.client = this.client = JSON.parse(getItem('return-client'));
  }
}
</script>

<style scoped>
.custom__button {
  width: 250px;
  height: 30px;
  display: flex;
  padding: 7px;
  max-width: 250px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess);
  font-size: 16px;
  line-height: 24px;
  color: #fff!important;
}
.column {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>